import UserInfo from './UserInfo'

export default class RegisteredUserInfo extends UserInfo {
  public result: boolean
  public emailSubscription: boolean
  public productCategory: number[]
  public field: number[]
  public updateDttm: string

  constructor(model: UserInfoModel) {
    super()
    this.result = model.result
    this.email = model.email
    this.firstname = model.firstname
    this.lastname = model.lastname
    this.firstKanaName = model.firstKanaName
    this.lastKanaName = model.lastKanaName
    this.organization = model.organization
    this.jobRoles = model.jobRoles
    this.phone = model.phone
    this.mobilePhone = model.mobilePhone
    this.countryRegion = model.countryRegion
    this.address = model.address
    this.city = model.city
    this.state = model.state
    this.zipCode = model.zipCode
    this.department = model.department
    this.industry = model.industry
    this.emailSubscription = model.emailSubscription
    this.productCategory = model.productCategory
    this.field = model.field
    this.updateDttm = model.updateDttm
    this.locale = model.locale
  }
}

export class UserInfoModel {
  result = false
  email = ''
  firstname = ''
  lastname = ''
  firstKanaName = ''
  lastKanaName = ''
  organization = ''
  jobRoles = ''
  phone = ''
  mobilePhone = ''
  countryRegion = ''
  address = ''
  city = ''
  state = ''
  department = ''
  industry = ''
  zipCode = ''
  emailSubscription = false
  productCategory: number[] = []
  field: number[] = []
  updateDttm = ''
  locale = ''
}

export const jsobRoles: string[] = [
  'R&D',
  'Manufacturing',
  'Sales',
  'Marketing',
  'Other'
]
